"use client"

import { MessageSquareDot } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MessageSquareDotIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MessageSquareDotIcon = component(Icon)({ as: MessageSquareDot })
